import axios from "axios";
import qs from "qs";
import x2js from "x2js";
const X2JS = new x2js();
import { mapState, mapActions, mapGetters } from "vuex";

let data = {
  ...mapState({
    token: state => state.user.token
  })
};

axios.defaults.withCredentials = true;

const reg = new RegExp("[\u4e00-\u9fa5]");
const errorHandler = function(code, msg) {
  let codeMsg = errorEnums[code] ? errorEnums[code] : "";
  if (msg) {
    if (reg.test(msg)) {
      return { msg, code };
    }
    return { msg: codeMsg + msg, code };
  } else {
    return { msg: codeMsg, code };
  }
};
const ResponseHandler = function(response, successCallBack, failCallBack) {
  var resultXml = response.data;
  var resultJson = X2JS.xml2js(resultXml);
  resultJson = resultJson.ServiceResult;
  var resultCode = resultJson.ResultCode;
  if (resultCode && resultCode != 1) {
    var resultContent = resultJson.ResultContent;
    !!failCallBack & failCallBack(resultContent);
  } else {
    !!successCallBack &
      successCallBack(
        resultJson.ResultData,
        resultJson.CurrentPage,
        resultJson.ResultPages
      );
  }
};

const YC_REQUEST_HANDLER = {
  postQuery: function(url, queryMap, successCallBack, failCallBack) {
    var header = {};
    header["Content-Type"] = "application/x-www-form-urlencoded";
    if (window.localStorage.token) {
      header["Authorization"] = "Bearer " + window.localStorage.token;
    }
    if (window.localStorage.user) {
      let dbUser = JSON.parse(window.localStorage.user),
        usrId = dbUser ? dbUser.usrId : 0;
      if (usrId > 0) {
        url = url + "?usrId=" + usrId;
      }
    }
    axios.post(url, qs.stringify(queryMap), { headers: header }).then(
      function(response) {
        response = response.data;
        if (!!response && !!response.code) {
          var code = response.code;
          if (code == 200) {
            !!successCallBack && successCallBack(response.data);
          } else {
            !!failCallBack &&
              failCallBack(errorHandler(response.code, response.message));
          }
        } else {
          !!failCallBack && failCallBack("请求失败，请联系客服");
        }
      },
      function(error) {
        console.log(error);
        !!failCallBack && failCallBack("网络错误");
      }
    );
  },
  getJsonWithQuery: function(url, params, successCallBack, failCallBack) {
    axios.get(url, null).then(
      function(response) {
        response = response.data;
        if (response) {
          !!successCallBack && successCallBack(response);
        } else {
          !!failCallBack && failCallBack(0, "请求失败，请联系客服", null);
        }
      },
      function(error) {
        !!failCallBack && failCallBack(0, "网络错误！", null);
      }
    );
  },
  PostXml: function(
    url,
    params,
    successCallBack,
    failCallBack,
    needCheckToken
  ) {
    if (!needCheckToken) {
      this.PostXmlWithoutCheckToken(url, params, successCallBack, failCallBack);
      return;
    }
    var token = window.localStorage.getItem("token");
    var validTime = window.localStorage.getItem("tokenValidTime");
    var _this = this;
    if (!token) {
      failCallBack(2000, "当前用户尚未授权，请先登录！", null);
      return;
    }
    if (validTime < new Date().getTime()) {
      axios
        .post("/api/v2/uc/user/update/token?token=" + token, { token: token })
        .then(
          function(response) {
            response = response.data;
            if (!!response && !!response.code) {
              var code = response.code;
              if (code == 200) {
                window.localStorage.setItem(
                  "token",
                  response.data.userToken.token
                );
                window.localStorage.setItem(
                  "tokenValidTime",
                  response.data.userToken.validTime
                );
                _this.PostXmlWithoutCheckToken(
                  url,
                  params,
                  successCallBack,
                  failCallBack
                );
                return;
              }
            }
            !!failCallBack &
              failCallBack(0, "自动授权失败，请重新登录！", null);
          },
          function(error) {
            !!failCallBack &
              failCallBack(0, "申请授权失败，请重新登录！", null);
          }
        );
    } else {
      _this.PostXmlWithoutCheckToken(
        url,
        params,
        successCallBack,
        failCallBack
      );
    }
  },
  PostXmlWithoutCheckToken: function(
    url,
    params,
    successCallBack,
    failCallBack
  ) {
    axios
      .post(url, params)
      .then(
        function(response) {
          ResponseHandler(response, successCallBack, failCallBack);
        },
        function(err) {
          !!failCallBack & failCallBack(err);
        }
      )
      .catch(function(err) {
        !!failCallBack & failCallBack(err);
      });
  },
  getJsonWithoutCheckToken: function(
    url,
    params,
    successCallBack,
    failCallBack
  ) {
    axios.get(url, null).then(
      function(response) {
        response = response.data;
        if (!!response && !!response.code) {
          var code = response.code;
          if (code == 200) {
            !!successCallBack && successCallBack(response.data);
          } else {
            !!failCallBack && failCallBack(response.code, response.message);
          }
        } else {
          !!failCallBack && failCallBack(0, "未知错误，请联系客服！");
        }
      },
      function(error) {
        !!failCallBack && failCallBack(0, error);
      }
    );
  },
  LogAccess: function(params) {
    axios.post("/api/log/access/add", params).then(
      function(response) {
        var res = response.data;
        if (res.code === "200") {
          var data = res.data;
          if (data) {
            // console.log(data);
          }
        } else {
          console.log(res.message);
        }
      },
      function(error) {
        console.log("log access error");
      }
    );
  }
};
const errorEnums = {
  200: "成功",
  0: "未知错误",
  1000: "数据库操作失败",
  1001: "数据库繁忙",
  1010: "参数错误",
  1011: "缺少参数",
  1100: "手机号有误",
  1101: "手机号已注册/绑定",
  1102: "发送手机验证码失败",
  1103: "发送手机验证码次数过多",
  1104: "手机验证码错误",
  1105: "手机验证码过期",
  1106: "手机验证法发送太频繁，1分钟后重试",
  1107: "不支持的国家/地区手机号",
  1108: "当前用户已经绑定手机号",
  1110: "邮箱名有误",
  1111: "邮箱名已注册/绑定",
  1112: "邮箱验证码错误",
  1113: "邮箱验证码过期",
  1130: "昵称有误",
  1131: "昵称已被使用",
  1132: "用户昵称太长",
  1133: "用户昵称太短",
  1140: "无效的身份证号码",
  1141: "该身份证号码已使用",
  1150: "无效的图形验证码",
  1151: "请先获取图形验证码",
  1200: "新旧密码一样",
  1201: "密码错误",
  1202: "非法密码",
  1203: "用户未激活",
  1204: "用户名或者密码错误",
  1210: "不支持的用户注册类型",
  1301: "获取微信用户ID失败",
  1302: "获取微信用户ID错误",
  1310: "该手机号已绑定其他用户",
  1320: "不支持的微信小程序",
  1400: "微信服务器返回错误",
  1401: "当前用户已绑定其他微信",
  1402: "当前用户已绑定微信",
  1500: "二维码失效，请刷新",
  2000: "token失效",
  2010: "token超时,请重新登录！",
  2011: "TOKEN错误",
  2012: "token未找到",
  2100: "请先绑定微信账号",
  2101: "请先绑定手机号",
  2102: "请先绑定邮箱",
  2103: "saas服务器返回错误",
  2104: "saas服务器返回解析失败",
  2105: "saas服务器返回创建用户失败,请联系客服",
  2106: "请先设置登录密码",
  2107: "用户尚未绑定saas账户",
  2200: "用户尚未绑定指尖货运公众号",
  2300: "链接友舱服务器发生错误",
  2301: "saas服务器返回错误",
  2302: "saas服务器返回解析失败",
  3000: "用户不存在",
  3001: "用户未登录",
  3002: "此手机号码未在翌飞产品/网站上注册",
  3003: "此微信身份ID未在翌飞产品/网站/小程序上注册",
  3004: "此用户未在友舱官网注册，请前往www.yctop.com",
  3005: "用户未在友舱小程序注册",
  3006: "用户未在指尖货运小程序注册",
  3007: "邮箱已注册",
  4000: "申请qiniu-token次数太多，请12小时后再试",
  4001: "生成qiniu-token失败",
  5000: "系统异常",
  5001: "转换xml异常",
  6000: "组织/企业/公司不存在",
  6001: "企业/组织名称已被使用",
  6002: "当前用户已加入企业，无法创建新企业",
  6003: "当前用户已加入企业，无法加入其他企业",
  6004: "无权访问当前企业信息",
  6500: "邀请链接已失效",
  7001:"支付异常",
};

export default YC_REQUEST_HANDLER;
